import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {toast} from 'react-toastify';
import Spinner from '../../components/Spinner';
import { getOrders, getUnpaidOrders, reset } from '../../features/orders/orderSlice';
import OrderList from '../../components/admin/OrderList';



function AdminOrders({unpaid = false}) {
    const { orders, pagination, isLoading, isError, message } = useSelector((state) => state.order);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
      onlyNewOrders: false,
      onlyProcessingOrders: false,
      onlyMasterclassOrders: false,
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
      if (!user) {
        navigate('/');
      }
    }, [user, navigate]);

    useEffect(() => {
        if(isError) {
          toast.error(message)
        }
    }, [isError, message]);

    useEffect(() => {
        return () => {
            dispatch(reset());
        };
    }, [dispatch]);
    
    
      useEffect(() => {
        const params = { page: currentPage };

        if (!unpaid) {
          if (filters.onlyMasterclassOrders) {
            params.status = 'new';
            params.digital = true;
          } else if (filters.onlyNewOrders) {
            params.status = 'new';
            params.digital = false;
          } else if (filters.onlyProcessingOrders) {
            params.status = 'processing';
          }
        }

        unpaid ? dispatch(getUnpaidOrders(params)) : dispatch(getOrders(params));
      }, [dispatch, unpaid, currentPage, filters.onlyNewOrders, filters.onlyProcessingOrders, filters.onlyMasterclassOrders]);

      const handleFiltersChange = (nextFilters) => {
        setFilters(nextFilters);
        setCurrentPage(1);
      };

      if(!orders || isLoading) return <Spinner />;

  return (
    <div className='admin'>
        <OrderList
          orders={orders}
          unpaid={unpaid}
          pagination={pagination}
          filters={filters}
          onFiltersChange={handleFiltersChange}
          onPageChange={setCurrentPage}
        />
    </div>
  );
}

export default AdminOrders;
